import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navbar menu"
}
const _hoisted_2 = {
  key: 0,
  class: "nav-item-container menu-list"
}
const _hoisted_3 = {
  key: 1,
  class: "nav-item-container menu-list"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import { ATTENDANT_TRIAGE_FLOWS_ENABLED } from '@/store/app/featureTypes';
import { useAuth } from '@/authentication/useAuth';
import NavBarMenuItem from '@shared/components/navbar/NavBarMenuItem.vue';
import SettingsNavMenu from '@shared/components/navbar/SettingsNavMenu.vue';
import { useRoute } from 'vue-router';

// Vuex store

export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const store = useStore();

const { isAuthenticated } = useAuth();

// Computed properties (Vuex getters)
const isWorkspaceFeatureEnabled = computed(() => store.getters.isWorkspaceFeatureEnabled);
const botsLandingPage = computed(() =>
  isWorkspaceFeatureEnabled.value(ATTENDANT_TRIAGE_FLOWS_ENABLED, true) ? '/bots/tasks' : '/bots/flows',
);

const route = useRoute();
const activeRouteName = computed(() => String(route?.name || ''));
const isPlatformAdminRoute = computed(() => activeRouteName.value.startsWith('platform-admin'));

return (_ctx: any,_cache: any) => {
  return (_unref(isAuthenticated))
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo-container" }, [
          _createElementVNode("div", { class: "navbar__logo" })
        ], -1)),
        (!isPlatformAdminRoute.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              _createVNode(NavBarMenuItem, {
                icon: "comment-alt",
                path: "/web-assistant",
                "selected-route-prefix": ['web-assistant', 'root']
              }),
              _createVNode(NavBarMenuItem, {
                icon: "robot",
                path: botsLandingPage.value,
                "selected-route-prefix": "bots"
              }, null, 8, ["path"]),
              _createVNode(NavBarMenuItem, {
                icon: "user-friends",
                path: "/contacts",
                "selected-route-prefix": "contacts"
              }),
              _createVNode(NavBarMenuItem, {
                icon: "chart-area",
                path: "/reports/overview",
                "selected-route-prefix": "reports"
              }),
              _createVNode(NavBarMenuItem, {
                icon: "cubes",
                path: "/apps",
                "selected-route-prefix": "apps"
              }),
              _createVNode(NavBarMenuItem, {
                icon: "code",
                path: "/your-apps",
                "selected-route-prefix": "private-apps"
              })
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              _createVNode(NavBarMenuItem, {
                icon: "warehouse",
                path: "/platform-admin/workspaces",
                "selected-route-prefix": "platform-admin-workspace"
              }),
              _createVNode(NavBarMenuItem, {
                icon: "users-gear",
                path: "/platform-admin/users",
                "selected-route-prefix": "platform-admin-users"
              })
            ])),
        _createVNode(SettingsNavMenu)
      ]))
    : _createCommentVNode("", true)
}
}

})